//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { CheckAvailableChats } from '@api/chat.service'

export default {
  props: {
    shop: {
      required: true,
    },
    showRate: {
      type: Boolean,
      default: false,
    },
    showContact: {
      type: Boolean,
      default: false,
    },
    showMenu: {
      type: Boolean,
      default: true,
    },
    title: {},
    subject: {},
    classname: {
      type: String,
      default: '',
    },
    canShopReviews: {
      type: Boolean,
      default: false,
    },
    canChat: {
      type: Boolean,
      default: true,
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chats: {},
    }
  },
  watch: {
    shop: {
      handler() {
        if (this.shop && this.shop.id) {
          this.checkChats()
        }
      },
      immediate: true,
    },
  },
  methods: {
    getChat(id) {
      return this.chats[id] || 'None'
    },
    async checkChats() {
      if (!window.authent) return
      const { id } = (await CheckAvailableChats.execute({ shop: this.shop.id }))
      this.$set(this.chats, this.shop.id, id)
      this.chats[this.shop.id] = id
    },
  },
}
